import React, { useEffect, useState } from "react";
import styles from "./divineracademy.module.css";

import { Box, Link, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Common_html from "./components/Common_html";
import BlockData from "../../diviner-academy-json/diviner-academy.json";
import Head from "next/head";
import Image from "next/image";

export default function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:900px)");

  let logoBanner = "/image/logobanner_desktop.webp";

  if (isMobile) {
    logoBanner = "/image/logobanner.webp";
  } else if (isTablet) {
    logoBanner = "/image/logobanner.webp";
  }
  return (
    <>
      <Head>
        <title>Astrological Theurgy & Diviner Academy | School of Our Divine Infinite Being</title>
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta
          name="keywords"
          content="Astrological Theurgy, Diviner Academy, Astrology Certification, Tarot Certification, Spiritual Renewal, Sacred Knowledge, Theurgy Training, Divine Infinite Being"
        />
        <meta
          name="description"
          content="Explore Astrological Theurgy and the Divine Manifestation of the Future at our Diviner Academy. Study astrology, tarot, and the sacred art of theurgy in a path of sacred knowledge, service, and spiritual renewal."
        />

        <meta name="author" content="School of Our Divine Infinite Being" />
        <meta name="subject" content="Astrological Theurgy, Diviner Academy, Spiritual Education" />
        <meta name="language" content="English" />
        <meta name="geo.region" content="US" />

        <meta
          property="og:title"
          content="Astrological Theurgy and Diviner Academy | School of Our Divine Infinite Being"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/eddie_paredes_bio_og_img.webp"
        />
        <meta
          property="og:image:alt"
          content="Astrological Theurgy and Diviner Academy illustration"
        />
        <meta
          property="og:description"
          content="Join the Diviner Academy to study astrology, tarot, and astrological theurgy. Discover a path of sacred knowledge, practical service, and spiritual renewal."
        />
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/diviner-academy"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/eddie_paredes_bio_og_img.webp"
        />
        <meta
          property="twitter:title"
          content="Astrological Theurgy and Diviner Academy | School of Our Divine Infinite Being"
        />
        <meta
          property="twitter:url"
          content="https://www.divineinfinitebeing.com/diviner-academy"
        />
        <meta
          property="twitter:description"
          content="Explore astrology, tarot, and theurgy at our Diviner Academy. A sacred path of wisdom, service, and spiritual transformation."
        />

        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />

        <link rel="canonical" href="https://www.divineinfinitebeing.com/diviner-academy" />
      </Head>


      <div className={styles.diviner_academy_block_1}>
        <div className={styles.diviner_academy_banner_main_wrpr}>
          <div className={styles.diviner_academy_banner_left}>
            <div className={styles.bannerLogo}>
              <span className={styles.logoviewlink} onClick={handleOpen}>
                <Image
                  src="/image/viewicon.webp"
                  alt="View Icon"
                  width={400}
                  height={100}
                  style={{ width: "100%", height: "auto" }}
                  priority={true}
                  placeholder="blur"
                  blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                />
              </span>
              <Image
                src="/image/logobanner_cropped.webp"
                alt="School of Our Divine Infinite Being Logo"
                width={332}
                height={332}
                style={{ width: "100%", height: "auto" }}
                priority={true}
                placeholder="blur"
                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
              />
            </div>
            <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
            <h1 data-text="infinite being">INFINITE BEING</h1>

            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
            <div
              className={`${styles.diviner_academy_bottombannerbg} ${styles.bannerboxtxt}`}
            >
              <div className={styles.yellow_bar}></div>
            </div>
          </div>
        </div>
      </div>

      <Common_html BlockData={BlockData} />
      {/* -----------------------------------------modal---------------------------------- */}
      {showOtherBlocks && (
        <>
          {/* ===================== Chapters end=============== */}

          {/* ==================== modal =================== */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box">
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="modal_banner"
                component="div"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleClose}>
                    <CloseIcon />
                  </span>

                  <Image
                    src={logoBanner}
                    alt="bannerLogo"
                    width={400}
                    height={100}
                    style={{ width: "100%", height: "100%" }}
                    priority={false}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />
                </div>
              </Typography>
            </Box>
          </Modal>
        </>
      )}
    </>
  );
}
